import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance, axiosNewApiInstance } from "../../services/api.js";

// ! ======================== CLIENTS IN WORK PAGE ============================

// ! Statistics

// Get stats list +
export const getStatsList = createAsyncThunk(
  "accounting/getStatsList",
  async (period, thunkAPI) => {
    try {
      const { from_date, to_date } = period;
      const response = await axiosNewApiInstance.get(
        `/api/v1/in_work/statistics`,
        {
          params: {
            from_date,
            to_date,
          },
        }
      );
      console.log("getStatsList", response.data);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return thunkAPI.rejectWithValue({ status: 404, message: "Not found" });
      }
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// ! Clients in work list

// Get list of all clients in work +
export const getClientsInWork = createAsyncThunk(
  "accounting/getClientsInWork",
  async (period, thunkAPI) => {
    try {
      const { from_date, to_date } = period;

      const response = await axiosNewApiInstance.get(`/api/v1/in_work/`, {
        params: {
          from_date,
          to_date,
        },
      });
      console.log("getClientsInWork", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get parts search status +
export const getPartsSearchStatus = createAsyncThunk(
  "accounting/getPartsSearchStatus",
  async (diagnostic_id, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/diagnostics/status_search?diagnostic_id=${diagnostic_id}`
      );
      console.log("getPartsSearchStatus", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get all info of the record +
export const getRecordInfo = createAsyncThunk(
  "accounting/getRecordInfo",
  async (record_id, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/records/info/${record_id}`
      );
      console.log("getRecordInfo", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// ! Diagnostics

// Get Buffer Diagnostic +
export const getBufferDiagnostic = createAsyncThunk(
  "accounting/getBufferDiagnostic",
  async (diagnostic_id, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/buffer-diagnostics/${diagnostic_id}`
      );
      console.log("getBufferDiagnostic", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get tree of categories and parts +
export const getDiagnosticTree = createAsyncThunk(
  "accounting/getDiagnosticTree",
  async (vin, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/diagnostics/get_diagnostic_tree?vin=${vin}`
      );
      console.log("getDiagnosticTree", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get part details from diagnostic tree +
export const getPartDetails = createAsyncThunk(
  "accounting/getPartDetails",
  async (details, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/diagnostics/get_part_details`,
        details
      );
      console.log("getPartDetails", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get Nodes and Parts list +
export const getNodesAndParts = createAsyncThunk(
  "accounting/getNodesAndParts",
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/diagnostics/categories_with_parts`
      );
      console.log("getNodesAndParts", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get particular diagnostic +
export const getDiagnostic = createAsyncThunk(
  "accounting/getDiagnostic",
  async (diagnostic_id, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/diagnostics/${diagnostic_id}`
      );
      console.log("getDiagnostic", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Create diagnostic +
export const createDiagnostic = createAsyncThunk(
  "accounting/createDiagnostic",
  async (diagnosticData, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/diagnostics/`,
        diagnosticData
      );
      console.log("createDiagnostic", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Patch diagnostic +
export const patchDiagnostic = createAsyncThunk(
  "accounting/patchDiagnostic",
  async (updateData, thunkAPI) => {
    try {
      const { diagnostic_id, ...body } = updateData;
      const response = await axiosNewApiInstance.patch(
        `/api/v1/diagnostics/${diagnostic_id}`,
        body
      );
      console.log("patchDiagnostic", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Restart search parts +
export const restartSearchParts = createAsyncThunk(
  "accounting/restartSearchParts",
  async (diagnostic_id, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/positions/find-parts/${diagnostic_id}/restart`
      );
      console.log("restartSearchParts", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Delete diagnostic +
export const deleteDiagnostic = createAsyncThunk(
  "accounting/deleteDiagnostic",
  async ({ diagnostic_id, delete_reason }, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.delete(
        `/api/v1/diagnostics/${diagnostic_id}`,
        { data: { delete_reason } }
      );
      console.log("deleteDiagnostic", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// ! Commercial Offer

// Get data for Commercial Offer Modal +
export const getCommercialOfferData = createAsyncThunk(
  "accounting/getCommercialOfferData",
  async (diagnostic_id, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/positions/diagnostics/${diagnostic_id}`
      );
      console.log("getCommercialOfferData", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Create Commercial Offer +
export const createCommercialOffer = createAsyncThunk(
  "accounting/createCommercialOffer",
  async (data, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/commercial-offers/`,
        data
      );
      console.log("createCommercialOffer", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get Commercial Offer +
export const getCommercialOffer = createAsyncThunk(
  "accounting/getCommercialOffer",
  async (offer_id, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/commercial-offers/${offer_id}`
      );
      console.log("getCommercialOffer", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Update Commercial Offer +
export const updateCommercialOffer = createAsyncThunk(
  "accounting/updateCommercialOffer",
  async (updateComOfferData, thunkAPI) => {
    try {
      const { offer_id, ...updateData } = updateComOfferData;
      const response = await axiosNewApiInstance.patch(
        `/api/v1/commercial-offers/${offer_id}`,
        updateData
      );
      console.log("updateCommercialOffer", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get parts offer by OEM +
export const getPartsOfferByOEM = createAsyncThunk(
  "accounting/getPartsOfferByOEM",
  async (oem, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/suppliers/get-api-offers?oem=${oem}`
      );
      console.log("getPartsOfferByOEM", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Send commercial offer via E-mail to client for approval +
export const sendComOffer = createAsyncThunk(
  "accounting/sendComOffer",
  async (sendData, thunkAPI) => {
    const { offer_id } = sendData;
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/commercial-offers/send/${offer_id}`,
        sendData
      );
      console.log("sendComOffer", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Send commercial offer via SMS to client for approval +
export const sendSMSComOffer = createAsyncThunk(
  "accounting/sendSMSComOffer",
  async (sendData, thunkAPI) => {
    const { offer_id } = sendData;
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/commercial-offers/send-sms/${offer_id}`,
        sendData
      );
      console.log("sendSMSComOffer", response.data);
      const serviceId = thunkAPI.getState().auth.userData?.selectedServiceId;
      return { ...response.data, service_id: serviceId };
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail,
      });
    }
  }
);

// Manually Approve commercial offer +
export const manuallyApproveComOffer = createAsyncThunk(
  "accounting/manuallyApproveComOffer",
  async (data, thunkAPI) => {
    try {
      const { offer_id, ...status } = data;

      const response = await axiosNewApiInstance.patch(
        `/api/v1/commercial-offers/${offer_id}/status`,
        status
      );
      console.log("manuallyApproveComOffer", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Initialize additional search +
export const startAdditionalSearch = createAsyncThunk(
  "accounting/startAdditionalSearch",
  async (query, thunkAPI) => {
    try {
      const { oem, diagnostic_id } = query;
      const response = await axiosNewApiInstance.post(
        `/api/v1/positions/find_long_parts/${diagnostic_id}/${oem}`
      );
      console.log("startAdditionalSearch", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get additional offer +
export const getAdditionalOffer = createAsyncThunk(
  "accounting/getAdditionalOffer",
  async (query, thunkAPI) => {
    try {
      const { taskId } = query;
      const response = await axiosNewApiInstance.get(
        `/api/v1/positions/find_long_parts/task/${taskId}`
      );
      console.log("getAdditionalOffer", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Delete part from commercial offer +
export const deletePartFromComOffer = createAsyncThunk(
  "accounting/deletePartFromComOffer",
  async (partData, thunkAPI) => {
    try {
      const { offer_id, part_id } = partData;
      const response = await axiosNewApiInstance.delete(
        `/api/v1/commercial-offers/${offer_id}/parts/${part_id}`
      );
      console.log("deletePartFromComOffer", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Delete service from commercial offer +
export const deleteServiceFromComOffer = createAsyncThunk(
  "accounting/deleteServiceFromComOffer",
  async (serviceData, thunkAPI) => {
    try {
      const { offer_id, service_id } = serviceData;
      const response = await axiosNewApiInstance.delete(
        `/api/v1/commercial-offers/${offer_id}/services/${service_id}`
      );
      console.log("deleteServiceFromComOffer", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Return part from CO to supplier +
export const returnPartFromCO = createAsyncThunk(
  "accounting/returnPartFromCO",
  async (returnData, thunkAPI) => {
    try {
      const { offer_id, part_id, ...rest } = returnData;
      const response = await axiosNewApiInstance.post(
        `/api/v1/commercial-offers/${offer_id}/parts/${part_id}/return`,
        rest
      );
      console.log("returnPartFromCO", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Move part from CO from (car to warehouse) +
export const movePartFromCO = createAsyncThunk(
  "accounting/movePartFromCO",
  async (moveData, thunkAPI) => {
    try {
      const { offer_id, part_id, ...rest } = moveData;
      const response = await axiosNewApiInstance.post(
        `/api/v1/commercial-offers/${offer_id}/parts/${part_id}/move-to-warehouse`,
        rest
      );
      console.log("movePartFromCO", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Delete commercial offer +
export const deleteCommercialOffer = createAsyncThunk(
  "accounting/deleteCommercialOffer",
  async ({ offer_id, delete_reason }, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.delete(
        `/api/v1/commercial-offers/${offer_id}`,
        { data: { delete_reason } }
      );
      console.log("deleteCommercialOffer", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// ! Order
// Get data to create Order
export const getDataForOrder = createAsyncThunk(
  "accounting/getDataForOrder",
  async (car_id, thunkAPI) => {
    const state = thunkAPI.getState();
    const serviceId = state.auth.userData.selectedServiceId;
    try {
      const response = await axiosInstance.get(
        `/acc/get_order/?car_id=${car_id}`,
        {
          headers: {
            // "X-Api-Key": "YA7NxysJ",
            "company-id": serviceId,
          },
        }
      );
      console.log("getDataForOrder", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Send Order +
export const sendOrder = createAsyncThunk(
  "accounting/sendOrder",
  async (order_id, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/supplier-orders/confirm/${order_id}`
      );
      console.log("sendOrder", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get particular order by ID +
export const getParticularOrderByID = createAsyncThunk(
  "accounting/getParticularOrderByID",
  async (order_id, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/supplier-orders/${order_id}`
      );
      console.log("getParticularOrderByID", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Delete order +
export const deleteOrder = createAsyncThunk(
  "accounting/deleteOrder",
  async ({ order_id, delete_reason }, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.delete(
        `/api/v1/supplier-orders/${order_id}`,
        { data: { delete_reason } }
      );
      console.log("deleteOrder", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// ! RECEIVED PARTS

// Get details of the receiving of order from particular supplier +
export const getReceivingDetails = createAsyncThunk(
  "accounting/getReceivingDetails",
  async (payload, thunkAPI) => {
    console.log("getReceivingDetails payload", payload);
    const { received_id, scenario } = payload;
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/receiveds/${received_id}`,
        {
          params: {
            scenario,
          },
        }
      );
      // console.log("getReceivingDetails", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Delete receiving document +
export const deleteReceivingDocument = createAsyncThunk(
  "accounting/deleteReceivingDocument",
  async ({ received_id, delete_reason }, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.delete(
        `/api/v1/receiveds/${received_id}`,
        { data: { delete_reason } }
      );
      console.log("deleteReceivingDocument", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// ! Repair
// Get repair info +
export const getRepair = createAsyncThunk(
  "accounting/getRepair",
  async (repair_id, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/repairs/${repair_id}`
      );
      console.log("getRepair", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Update Repair Info
export const updateRepair = createAsyncThunk(
  "accounting/updateRepair",
  async (updatedRepairData, thunkAPI) => {
    const state = thunkAPI.getState();
    const serviceId = state.auth.userData.selectedServiceId;
    try {
      const { repair_id, ...repairData } = updatedRepairData;
      const response = await axiosNewApiInstance.patch(
        `/api/v1/repairs/${repair_id}`,
        repairData,
        {
          headers: {
            // "X-Api-Key": "YA7NxysJ",
            "company-id": serviceId,
          },
        }
      );
      console.log("updateRepair", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Update repair part status +
export const updateRepairParts = createAsyncThunk(
  "accounting/updateRepairParts",
  async (partData, thunkAPI) => {
    const { repair_id, part_id, ...body } = partData;
    try {
      const response = await axiosNewApiInstance.patch(
        `/api/v1/repairs/${repair_id}/parts/${part_id}`,
        body
      );
      console.log("updateRepairParts", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Update repair service +
export const updateRepairService = createAsyncThunk(
  "accounting/updateRepairService",
  async (serviceData, thunkAPI) => {
    const { repair_id, service_id, ...body } = serviceData;
    try {
      const response = await axiosNewApiInstance.patch(
        `/api/v1/repairs/${repair_id}/services/${service_id}`,
        body
      );
      console.log("updateRepairService", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Complete repair +
export const completeRepair = createAsyncThunk(
  "accounting/completeRepair",
  async (repairDetails, thunkAPI) => {
    try {
      const { repair_id, ...status } = repairDetails;
      const response = await axiosNewApiInstance.patch(
        `/api/v1/repairs/${repair_id}/status`,
        status
      );
      console.log("completeRepair", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Finish repair +
export const finishRepair = createAsyncThunk(
  "accounting/finishRepair",
  async (finishData, thunkAPI) => {
    try {
      const { recordId, ...body } = finishData;
      const response = await axiosNewApiInstance.post(
        `/api/v1/records/${recordId}/completed`,
        body
      );
      console.log("finishRepair", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Change repair completed date +
export const changeRepairCompletedDate = createAsyncThunk(
  "accounting/changeRepairCompletedDate",
  async ({ recordId, complete_date }, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.patch(
        `/api/v1/repairs/${recordId}/completed_date`,
        { complete_date }
      );
      console.log("changeRepairCompletedDate", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Delete repair +
export const deleteRepair = createAsyncThunk(
  "accounting/deleteRepair",
  async ({ repair_id, delete_reason }, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.delete(
        `/api/v1/repairs/${repair_id}`,
        { data: { delete_reason } }
      );
      console.log("deleteRepair", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// ! RETURN CAR TO THE CUSTOMER
// return car to the customer +
export const returnCarToCustomer = createAsyncThunk(
  "accounting/returnCarToCustomer",
  async (recordId, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/in_work/${recordId}/returned`
      );
      console.log("returnCarToCustomer", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);
